<template>
  <h2 class="text-3xl sm:text-4xl font-medium leading-none" :class="[textColor, { 'mb-3 sm:mb-5': !flush }]">
    <slot />
  </h2>
</template>

<script setup lang="ts">
defineProps({
  textColor: { type: String, required: false, default: 'text-app-primary-1-red--fire-brick' },
  flush: { type: Boolean, required: false, default: false },
})
</script>
